const DEFAULT_STRAPI_URL = "https://api.srashtasoft.com"

const stripTrailingSlash = value => String(value || "").replace(/\/+$/, "")

export const getStrapiBaseUrl = () =>
  stripTrailingSlash(process.env.GATSBY_STRAPI_URL || DEFAULT_STRAPI_URL)

export const toStrapiMediaUrl = value => {
  if (!value) return value
  if (/^(?:https?:)?\/\//i.test(value) || value.startsWith("data:")) return value
  if (!value.startsWith("/")) return value

  return `${getStrapiBaseUrl()}${value}`
}
